<microsec-loading-overlay [isLoading]="!!isLoading">
  @if (!!threat) {
    <div class="grid grid-cols-12 gap-4">
      @if (!showThreatScoreDetails && !showImpactedDeviceDetails) {
        <div class="col-span-6" (click)="toggleShowThreatScoreDetails()">
          <microsec-card styleClass="detail-card cursor-pointer rounded-lg" [isNestedCard]="true" [isFull]="true">
            <div class="card-icon icon-container">
              <i class="fas fa-up-right-and-down-left-from-center icon"></i>
            </div>
            <div class="flex flex-col gap-4">
              <span class="text-grey"> Threat Score </span>
              <span class="text-2xl">
                {{ !!threat.threat_score ? (threat.threat_score | threatScorePipe) + '/10' : '-' }}
              </span>
              <ng-container
                [ngTemplateOutlet]="threatScoreLabelTemplate"
                [ngTemplateOutletContext]="{ score: threat.threat_score | threatScorePipe }">
              </ng-container>
            </div>
          </microsec-card>
        </div>
        <div class="col-span-6" (click)="toggleShowImpactedDeviceDetails()">
          <microsec-card styleClass="detail-card cursor-pointer rounded-lg" [isNestedCard]="true" [isFull]="true">
            <div class="card-icon icon-container">
              <i class="fas fa-up-right-and-down-left-from-center icon"></i>
            </div>
            <div class="flex flex-col gap-4">
              <span class="text-grey">Impacted Device</span>
              <span class="text-2xl"> {{ threat.device_ids?.length || 0 }} {{ threat.device_ids?.length > 1 ? 'Devices' : 'Device' }} </span>
              <div class="overflow-hidden whitespace-nowrap text-ellipsis">
                <ng-container *ngFor="let device of threat.device_ids || []; let lastDevice = last">
                  <span class="text-grey"> {{ device.label || 'Device' + device.device_id }}<span *ngIf="!lastDevice">,</span> </span>
                </ng-container>
              </div>
            </div>
          </microsec-card>
        </div>
      }

      @if (!!showThreatScoreDetails) {
        <div [@verticalSlideAnimation] class="col-span-12">
          <microsec-card styleClass="detail-card rounded-lg" [isNestedCard]="true" [isFull]="true">
            <div class="flex items-center gap-2">
              <i class="pi pi-chevron-left cursor-pointer font-bold" (click)="toggleShowThreatScoreDetails()"></i>
              <span>Threat Score</span>
            </div>
            <div class="grid grid-cols-12 gap-4 mt-4 ml-4">
              <div class="col-span-4 pr-20">
                <div class="flex flex-col gap-4">
                  <span class="text-2xl">
                    {{ !!threat.threat_score ? (threat.threat_score | threatScorePipe) + '/10' : '-' }}
                  </span>
                  <ng-container
                    [ngTemplateOutlet]="threatScoreLabelTemplate"
                    [ngTemplateOutletContext]="{ score: threat.threat_score | threatScorePipe }">
                  </ng-container>
                </div>
              </div>
              <div class="col-span-8">
                <div class="flex flex-col gap-4">
                  <div class="grid grid-cols-12 gap-4">
                    <span class="col-span-12 md:col-span-4">Threat Impact Score</span>
                    <div class="col-span-12 md:col-span-8">
                      <microsec-score-scale [inputNumber]="threat.threat_impact" [tooltipText]="'Threat Impact Score'"></microsec-score-scale>
                    </div>
                  </div>
                  <div class="grid grid-cols-12 gap-4">
                    <span class="col-span-12 md:col-span-4">Threat Likelihood Score</span>
                    <div class="col-span-12 md:col-span-8">
                      <microsec-score-scale [inputNumber]="threat.threat_likelihood" [tooltipText]="'Threat Likelihood Score'"></microsec-score-scale>
                    </div>
                  </div>
                  <div class="grid grid-cols-12 gap-4">
                    <span class="col-span-12 lg:col-span-4">Threat Accuracy Score</span>
                    <div class="col-span-12 lg:col-span-8">
                      <microsec-score-scale [inputNumber]="threat.threat_accuracy" [tooltipText]="'Threat Accuracy Score'"></microsec-score-scale>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </microsec-card>
        </div>
      }

      @if (!!showImpactedDeviceDetails) {
        <div [@verticalSlideAnimation] class="col-span-12">
          <microsec-card styleClass="detail-card rounded-lg" [isNestedCard]="true" [isFull]="true">
            <div class="flex items-center gap-2">
              <i class="pi pi-chevron-left cursor-pointer font-bold" (click)="toggleShowImpactedDeviceDetails()"></i>
              <span>Impacted Devices</span>
            </div>
            <div class="flex flex-col gap-4 mt-4 ml-4">
              <span class="text-2xl"> {{ threat.device_ids?.length || 0 }} {{ threat.device_ids?.length > 1 ? 'Devices' : 'Device' }} </span>
              <div class="grid grid-cols-12 gap-4" *ngIf="!!threat.device_ids?.length">
                <span class="col-span-4 pr-20">Name</span>
                <div class="col-span-8">
                  <div class="flex flex-wrap gap-2">
                    <ng-container *ngFor="let device of threat.device_ids || []">
                      <p-chip class="cursor-pointer" [label]="device.label || 'Device' + device.device_id" (click)="goToDevicePage(device)"></p-chip>
                    </ng-container>
                  </div>
                </div>
              </div>
            </div>
          </microsec-card>
        </div>
      }

      <div class="col-span-12">
        <microsec-card styleClass="detail-card rounded-lg" [isNestedCard]="true" [isFull]="true">
          <div class="card-icon icon-container">
            <i class="fas fa-biohazard icon"></i>
          </div>
          <div class="flex flex-col gap-4">
            <span class="text-grey"> Threat Details </span>
            <span class="text-2xl">
              {{ threat | threatTitlePipe }}
            </span>
            @if (threat.threat_type !== THREAT_TYPES.NON_COMPLIANCE && !!threat.descriptionPreview) {
              <span class="text-grey markdown-preview" [innerHTML]="threat.descriptionPreview"></span>
            } @else {
              <span class="text-grey">
                {{
                  threat.threat_type === THREAT_TYPES.NON_COMPLIANCE
                    ? 'MicroIDS has detected non-compliance from the following assessment(s).'
                    : 'MicroIDS has detected suspicious and unusual behavior that may indicate ' +
                      THREAT_TYPE_DESCRIPTIONS[threat.threat_type] +
                      ' in your network.'
                }}
              </span>
            }
            <div class="list-fields mx-4">
              <div class="grid grid-cols-12 gap-4 items-center">
                <span class="col-span-4 font-bold"> Created Date </span>
                <span class="col-span-8 text-grey"> {{ threat?.created | momentPipe }} </span>
              </div>
              <div class="grid grid-cols-12 gap-4 items-center" *ngIf="threat?.updatableStatus">
                <span class="col-span-4 font-bold items-center">
                  <span>Status</span>
                  <span
                    class="pi pi-info-circle ml-2"
                    pTooltip="Use status to track threat progress.<br/><br/> Setting status to 'Closed (False Alarm)' helps MicroIDS improve detection accuracy and reduce similar alerts."
                    [escape]="false"
                    tooltipPosition="top"
                    appendTo="body"></span>
                </span>
                <div class="col-span-8">
                  <span [pTooltip]="!isValidLicense() ? INACTIVE_LICENSE : ''" tooltipPosition="right" appendTo="body">
                    <p-select
                      class="status-dropdown bordered-dropdown uppercase"
                      [ngClass]="{
                        'red-dropdown': threat.updatableStatus.toLowerCase() === 'open' && threat.updatableIsTruePositive === null,
                        'orange-dropdown': threat.updatableStatus.toLowerCase() === 'fixing' && threat.updatableIsTruePositive === true,
                        'green-dropdown': threat.updatableStatus.toLowerCase() === 'closed' && threat.updatableIsTruePositive === true,
                        'grey-dropdown': threat.updatableStatus.toLowerCase() === 'closed' && threat.updatableIsTruePositive === false
                      }"
                      [options]="threatStatusOptions"
                      optionLabel="label"
                      appendTo="body"
                      (onChange)="
                        (threat.status !== $event.value?.dataValue || threat.is_true_positive !== $event.value?.isTruePositive) &&
                          openUpdateStatusConfirmation($event.value)
                      "
                      [disabled]="!permissions[USER_ROLE.TECHNICIAN] || !!threat.is_imported || !isValidLicense()">
                      <ng-template #selectedItem>
                        <div [pTooltip]="threat | constant: 'threat-status-tooltip'" tooltipPosition="top" appendTo="body">
                          @if (threat.updatableStatus.toLowerCase() === 'closed') {
                            @if (!!threat.updatableIsTruePositive) {
                              <span class="fa fa-circle-check mr-1"></span>
                            } @else {
                              <span class="fa fa-bell-slash mr-1"></span>
                            }
                          }
                          <span>{{ threat | constant: 'threat-status' }}</span>
                        </div>
                      </ng-template>
                    </p-select>
                  </span>
                </div>
              </div>
              <div class="grid grid-cols-12 gap-4 items-center" *ngIf="!!threat.details?.affected_features?.length">
                <span class="col-span-4 font-bold"> Affected Features </span>
                <span class="col-span-8 text-grey"> {{ threat.details.affected_features.join(', ') }} </span>
              </div>
              <div
                class="grid grid-cols-12 gap-4 items-center"
                *ngIf="!!threat.attack_technique && threat.attack_technique?.toLowerCase() !== 'none'">
                <span class="col-span-4 font-bold"> Attack Technique </span>
                <span class="col-span-8 text-grey"> {{ threat.attack_technique }} </span>
              </div>
              <div class="grid grid-cols-12 gap-4 items-center" *ngIf="!!threat.details?.comparators?.length">
                <span class="col-span-4 font-bold"> Comparators </span>
                <span class="col-span-8 text-grey"> {{ threat.details.comparators.join(', ') }} </span>
              </div>
              <div class="grid grid-cols-12 gap-4 items-center" *ngIf="!!threat.snort_rule_id">
                <span class="col-span-4 font-bold"> Snort Rule ID </span>
                <div class="col-span-8">
                  <p-chip
                    class="cursor-pointer"
                    [label]="threat.snort_rule_id"
                    (click)="openSnortUrl(threat.snort_rule_id)"
                    [pTooltip]="threat?.details?.rule || ''"
                    tooltipPosition="right"
                    appendTo="body"></p-chip>
                </div>
              </div>
              <div class="grid grid-cols-12 gap-4 items-center" *ngIf="!!threat.cves?.length">
                <span class="col-span-4 font-bold"> Related CVEs </span>
                <div class="col-span-8 flex flex-wrap gap-2">
                  <ng-container *ngFor="let cve of threat.cves || []">
                    <p-chip class="cursor-pointer" [label]="cve" (click)="openUrl('https://nvd.nist.gov/vuln/detail/' + cve)"></p-chip>
                  </ng-container>
                </div>
              </div>
              <div
                class="grid grid-cols-12 gap-4 items-center"
                *ngIf="!!threat.mitre_technique_id && threat.mitre_technique_id.toLowerCase() !== 'none'">
                <span class="col-span-4 font-bold"> Mitre Technique ID </span>
                <div class="col-span-8">
                  <p-chip
                    class="cursor-pointer"
                    [label]="threat.mitre_technique_id"
                    (click)="openUrl('https://attack.mitre.org/techniques/' + threat.mitre_technique_id.split('.').join('/'))">
                  </p-chip>
                </div>
              </div>
              <div class="grid grid-cols-12 gap-4 items-center" *ngIf="!!threat.technique_name">
                <span class="col-span-4 font-bold"> Technique Name </span>
                <span class="col-span-8 text-grey"> {{ threat.technique_name }} </span>
              </div>
              <div class="grid grid-cols-12 gap-4 items-center" *ngIf="!!threat.vulnerability_package_name">
                <span class="col-span-4 font-bold"> Package Name </span>
                <span class="col-span-8 text-grey"> {{ threat.vulnerability_package_name }} </span>
              </div>
              <div class="grid grid-cols-12 gap-4 items-center" *ngIf="!!threat.vulnerability_package_version">
                <span class="col-span-4 font-bold"> Package Version </span>
                <span class="col-span-8 text-grey"> {{ threat.vulnerability_package_version }} </span>
              </div>

              <div class="grid grid-cols-12 gap-4 items-center" *ngIf="!!threat.vulnerability_service">
                <span class="col-span-4 font-bold"> Affected Service </span>
                <span class="col-span-8 text-grey"> {{ threat.vulnerability_service }} </span>
              </div>

              <div class="grid grid-cols-12 gap-4 items-center" *ngIf="!!threat.vulnerability_port">
                <span class="col-span-4 font-bold"> Affected Port </span>
                <span class="col-span-8 text-grey"> {{ threat.vulnerability_port }} </span>
              </div>

              <div class="grid grid-cols-12 gap-4 items-center" *ngIf="!!threat.assessments?.length">
                <span class="col-span-4 font-bold"> Assessment(s) </span>
                <div class="col-span-8 flex flex-wrap gap-2">
                  <ng-container *ngFor="let assessment of threat.assessments">
                    <p-chip class="cursor-pointer" [label]="assessment.name" (click)="goToAssessmentPage(assessment)"></p-chip>
                  </ng-container>
                </div>
              </div>
              <div class="grid grid-cols-12 gap-4 items-center" *ngIf="!!threat.assessmentTypes?.length">
                <span class="col-span-4 font-bold"> Assessment Type(s) </span>
                <div class="col-span-8 flex flex-wrap gap-2">
                  <ng-container *ngFor="let assessmentType of threat.assessmentTypes">
                    <p-chip class="cursor-pointer" [label]="assessmentType.name" (click)="goToAssessmentTypePage(assessmentType)"></p-chip>
                  </ng-container>
                </div>
              </div>
              <div class="grid grid-cols-12 gap-4 items-center" *ngIf="!!threat.attack_type">
                <span class="col-span-4 font-bold"> Attack Type </span>
                <span class="col-span-8 text-grey">
                  {{ threat.attack_type | constant: 'threat-attack-type' }}
                </span>
              </div>
              <div class="grid grid-cols-12 gap-4 items-center" *ngIf="!!threat.non_compliance_category">
                <span class="col-span-4 font-bold"> Category </span>
                <span class="col-span-8 text-grey">
                  {{ threat.non_compliance_category | uppercase }}
                </span>
              </div>
              <div
                class="grid grid-cols-12 gap-4 items-center"
                *ngIf="threat.threat_type === THREAT_TYPES.NON_COMPLIANCE && !!threat.descriptionPreview">
                <span class="col-span-4 font-bold"> Question Details </span>
                <div class="col-span-8 markdown-preview max-h-[30rem] overflow-auto text-grey" [innerHTML]="threat.descriptionPreview"></div>
              </div>

              <div *ngIf="!!threat.details?.payload"></div>
              @if (!!showAttackDetails && !!threat.details?.payload) {
                <div [@verticalSlideAnimation] class="mt-2">
                  <microsec-card styleClass="rounded-lg">
                    <div class="flex justify-between items-center">
                      <span class="font-bold"> Payload </span>
                      <p-selectButton
                        *ngIf="!!prettyPayload().length"
                        [options]="payloadViewOptions"
                        [(ngModel)]="selectedPayloadView"
                        optionValue="value"
                        [allowEmpty]="false">
                        <ng-template #item let-item>
                          <i [class]="item.icon"></i>
                        </ng-template>
                      </p-selectButton>
                    </div>
                    <p-divider />
                    <microsec-card styleClass="rounded-lg" [isNoPadding]="true" maxHeight="350px">
                      @if (selectedPayloadView === 'string') {
                        <span class="text-grey">
                          {{ threat.details?.payload || '-' }}
                        </span>
                      }
                      @if (selectedPayloadView === 'list') {
                        <div class="list-fields">
                          @for (payloadItem of parsedPrettyPayload(); track $index) {
                            <div class="grid grid-cols-12 gap-4 grid-nogutter items-center">
                              <span class="col-span-5 font-bold"> {{ payloadItem.label }} </span>
                              <span class="col-span-7 text-grey pl-6" [innerHTML]="payloadItem.value"> </span>
                            </div>
                          }
                        </div>
                      }
                    </microsec-card>
                  </microsec-card>
                </div>
              }
            </div>
            <div class="flex justify-center" *ngIf="!!threat.details?.payload">
              <div
                class="icon-container attack-details-toggle-button"
                [ngClass]="{ uncollapsed: !showAttackDetails }"
                (click)="toggleShowAttackDetails()">
                <i class="pi pi-chevron-down icon font-bold" [ngClass]="{ up: !!showAttackDetails }"></i>
                <span class="font-bold"></span>
              </div>
            </div>
          </div>
        </microsec-card>
      </div>

      <div class="col-span-12" *ngIf="!!threat?.connection_id || !!threat?.analyzer_id || !!threat?.detected_on">
        <microsec-card styleClass="detail-card rounded-lg" [isNestedCard]="true" [isFull]="true">
          <div class="card-icon icon-container">
            <i class="fas fa-bars icon"></i>
          </div>
          <div class="flex flex-col gap-4">
            <span class="font-bold">Other Information</span>
            <div class="list-fields mx-4">
              <div class="grid grid-cols-12 gap-4 items-center" *ngIf="!!threat?.connection_id">
                <span class="col-span-4 font-bold"> Network Connection </span>
                <div class="col-span-8">
                  <p-chip
                    class="cursor-pointer"
                    [label]="'Connection ID: ' + threat.connection_id"
                    (click)="goToConnectionPage(threat.connection_id)"></p-chip>
                </div>
              </div>
              <div class="grid grid-cols-12 gap-4 items-center" *ngIf="!!threat?.analyzer_id">
                <span class="col-span-4 font-bold"> Analyzer </span>
                <div class="col-span-8">
                  <p-chip
                    class="cursor-pointer"
                    [label]="'Analyzer ID: ' + threat.analyzer_id"
                    (click)="
                      goToAnalyzerPage(threat.analyzer_id, !!threat.snort_rule_id || threat.attack_type?.toLowerCase() === 'unknown')
                    "></p-chip>
                </div>
              </div>
              <div class="grid grid-cols-12 gap-4 items-center" *ngIf="!!threat?.detected_on">
                <span class="col-span-4 font-bold"> Detected on </span>
                <span class="col-span-8 text-grey">{{ threat.detected_on }}</span>
              </div>
            </div>
          </div>
        </microsec-card>
      </div>
    </div>
  }
</microsec-loading-overlay>

<ng-template let-score="score" #threatScoreLabelTemplate>
  <span
    [ngClass]="{
      'text-green': score < 4,
      'text-orange': score >= 4 && score < 8,
      'text-red': score >= 8
    }">
    {{ score < 4 ? 'Low Severity' : score >= 4 && score < 8 ? 'Medium Severity' : score >= 8 ? 'High Severity' : '-' }}
  </span>
</ng-template>

<ng-template #emptyTemplate>
  <span class="col-span-8"> - </span>
</ng-template>
